module.exports = __webpack_public_path__ + "static/icons/icon-caret-up--white-885fe56eeddfeff21d271efa212f499b.svg";